import { Loader2 } from "lucide-react";

export const SectionLoader = () => {
  return (
    <div className="w-full py-12 flex items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-primary/50" />
    </div>
  );
};
